import React from 'react';
import EC from '../Images/EC.png'
import { Link } from 'react-router-dom';
import Collapsebar from './Collapsebar';
import * as HIcons from "react-icons/hi";
import nav from '../JSON/NavFoot';

export default function NavbarHome(){
    return (
        <nav className='flex items-center px-4 md:px-16 justify-between font-semibold'>
        <div className='block lg:hidden'>
            <Collapsebar />
        </div>
        <div className='hidden lg:flex space-x-2'>
            <Link to={nav[0].link}>
                <div className='flex hover:bg-[#101242] p-4 rounded-md transition-colors duration-200 cursor-pointer space-x-2 text-[#ed5955] hover:text-[#F4DC7C]'>
                <HIcons.HiHome className='h-5 w-5'/>
            <span className='text-white'>
            {nav[0].title}
            </span>
                </div>
            </Link>
            <Link to={nav[1].link}>
                <div className='flex hover:bg-[#101242] p-4 rounded-md transition-colors duration-200 cursor-pointer space-x-2 text-[#ed5955] hover:text-[#F4DC7C]'>
                <HIcons.HiUser className='h-5 w-5'/>
            <span className='text-white'>
            {nav[1].title}
            </span>
                </div>
            </Link>
            <Link to={nav[2].link}>
                <div className='flex hover:bg-[#101242] p-4 rounded-md transition-colors duration-200 cursor-pointer space-x-2 text-[#ed5955] hover:text-[#F4DC7C]'>
                <HIcons.HiCalendar className='h-5 w-5'/>
            <span className='text-white'>
            {nav[2].title}
            </span>
                </div>
            </Link>
            <a target="_blank" rel="noreferrer" href={nav[3].link}>
                <div className='flex hover:bg-[#101242] p-4 rounded-md transition-colors duration-200 cursor-pointer space-x-2 text-[#ed5955] hover:text-[#F4DC7C]'>
                <HIcons.HiUserGroup className='h-5 w-5'/>
                <span className='text-white'>
                {nav[3].title}
            </span>
                </div>
            </a>
        </div>
        <img className='h-[18vw] md:h-32' src={EC} alt="EC Logo" />
    </nav>
    );
}